var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTransactionMinus({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/transaction-minus"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M7.22827 20.2C8.04827 19.32 9.29828 19.39 10.0183 20.35L11.0283 21.7C11.8383 22.77 13.1483 22.77 13.9583 21.7L14.9683 20.35C15.6883 19.39 16.9383 19.32 17.7583 20.2C19.5383 22.1 20.9883 21.47 20.9883 18.81V7.54C20.9883 3.51 20.0483 2.5 16.2683 2.5H8.70828C4.92828 2.5 3.98828 3.51 3.98828 7.54V18.8C3.99828 21.47 5.45827 22.09 7.22827 20.2Z",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.75 10.5H15.25",
    stroke: "#292D32",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionMinus);
export default __webpack_public_path__ + "static/media/transaction-minus.82bdf412a5f5d2bfbe9425fe2d6fd3f7.svg";
export { ForwardRef as ReactComponent };